import { ApolloError, useMutation } from '@apollo/client'

import { MutationUpdateObservationStatusArgs, ObservationStatusUpdateInput } from '@types'

import { MUTATION_UPDATE_OBSERVATION_STATUS } from '@libs/apollo/mutations/observation.mutation'

interface Data {
  updateStatusObservation: boolean
}

interface UseUpdateStatusObservationProps {
  onCompleted?: () => void
}

export const useUpdateStatusObservation = (
  props?: UseUpdateStatusObservationProps,
): {
  updateStatusObservation: (input: ObservationStatusUpdateInput) => void
  loading: boolean
  error: ApolloError | undefined
  data?: Data | null
} => {
  const [updateStatusObservation, { loading, error, data }] = useMutation<Data, MutationUpdateObservationStatusArgs>(
    MUTATION_UPDATE_OBSERVATION_STATUS,
    {
      notifyOnNetworkStatusChange: true,
    },
  )

  const _updateStatusObservation = (input: ObservationStatusUpdateInput) => {
    updateStatusObservation({
      variables: { input },
      onCompleted: props?.onCompleted,
      update(cache) {
        cache.modify({
          id: cache.identify({ id: input.observationId, __typename: 'Observation' }),
          fields: {
            status: () => input.status,
          },
        })
      },
    })
  }

  return { updateStatusObservation: _updateStatusObservation, loading, error, data }
}
